export const UNKNOWN_STATUS_MSG = 'UNKNOWN STATUS';
export const NETWORK_ERROR_MSG = 'Error occurred reading network response';
export const GATEWAY_TIMEOUT_MSG = 'Gateway timeout';
export const UNAUTHORIZED_ERROR_CODE = 'UNAUTHORIZED';
